"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ControlSwitch;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

var Switch = _interopRequireWildcard(require("@radix-ui/react-switch"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ControlSwitch(props) {
  var id = props.id,
      onChange = props.onChange,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      validationError = props.validationError,
      label = props.label,
      _props$value = props.value,
      value = _props$value === void 0 ? false : _props$value,
      _props$themeControlWr = props.themeControlWrapper,
      themeControlWrapper = _props$themeControlWr === void 0 ? '' : _props$themeControlWr,
      _props$themeControlSw = props.themeControlSwitchContainer,
      themeControlSwitchContainer = _props$themeControlSw === void 0 ? '' : _props$themeControlSw,
      _props$themeControlSw2 = props.themeControlSwitch,
      themeControlSwitch = _props$themeControlSw2 === void 0 ? 'switch--s-label' : _props$themeControlSw2,
      _props$themeLabel = props.themeLabel,
      themeLabel = _props$themeLabel === void 0 ? 'txt-s ml6' : _props$themeLabel;
  var switchProps = {
    id: id,
    checked: value,
    disabled: disabled,
    onCheckedChange: function onCheckedChange(v) {
      return onChange(v, id);
    },
    'data-testid': "".concat(id, "-switch")
  };
  var labelClasses = (0, _classnames.default)("switch-container ".concat(themeControlSwitchContainer), {
    'cursor-pointer': !disabled
  });
  return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
    themeControlWrapper: themeControlWrapper,
    id: id,
    validationError: validationError
  }, /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "flex flex--center-cross"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: labelClasses
  }, /*#__PURE__*/_react.default.createElement(Switch.Root, _extends({}, switchProps, {
    className: "switch ".concat(themeControlSwitch)
  }), /*#__PURE__*/_react.default.createElement(Switch.Thumb, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: themeLabel
  }, label))));
}

ControlSwitch.propTypes = {
  /** Identifying value for input element. */
  id: _propTypes.default.string.isRequired,

  /** Input value */
  value: _propTypes.default.bool,

  /** Called during changes to the input element. Two arguments are received: 1. The incoming value and 2. the ID of the input. */
  onChange: _propTypes.default.func.isRequired,

  /** Value passed to the label element. */
  label: _propTypes.default.node,

  /** If provided, the value of this propery displays as an error message. */
  validationError: _propTypes.default.node,

  /** Assembly classes to apply to the switch container */
  themeControlSwitchContainer: _propTypes.default.string,

  /** Assembly classes to apply to the switch element */
  themeControlSwitch: _propTypes.default.string,

  /** Assembly classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string,

  /** Assembly classes to apply to the label element */
  themeLabel: _propTypes.default.string
};